export default {
  registration_number: "Registration Number",
  master_student: "Master Student Registration Number",
  master_teacher: "Master Teacher Registration Number",
  master_staff: "Master Staff Registration Number"
};
